/**
 * PropTypes definitions for Contents component
 * @module types/contentsTypes
 */

import PropTypes from 'prop-types';

/**
 * Request shape used for async operations
 */
export const requestShape = PropTypes.shape({
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
});

/**
 * Breadcrumb item shape
 */
export const breadcrumbShape = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
});

/**
 * Content item shape
 */
export const contentItemShape = PropTypes.shape({
  '@id': PropTypes.string,
  '@type': PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
});

/**
 * PropTypes for Contents component
 */
export const contentsPropTypes = {
  action: PropTypes.string,
  source: PropTypes.arrayOf(PropTypes.string),
  searchContent: PropTypes.func.isRequired,
  cut: PropTypes.func.isRequired,
  copy: PropTypes.func.isRequired,
  copyContent: PropTypes.func.isRequired,
  deleteContent: PropTypes.func.isRequired,
  moveContent: PropTypes.func.isRequired,
  orderContent: PropTypes.func.isRequired,
  sortContent: PropTypes.func.isRequired,
  updateColumnsContent: PropTypes.func.isRequired,
  clipboardRequest: requestShape.isRequired,
  deleteRequest: requestShape.isRequired,
  updateRequest: requestShape.isRequired,
  searchRequest: requestShape.isRequired,
  items: PropTypes.arrayOf(contentItemShape),
  breadcrumbs: PropTypes.arrayOf(breadcrumbShape).isRequired,
  total: PropTypes.number.isRequired,
  pathname: PropTypes.string.isRequired,
};

/**
 * Default props for Contents component
 */
export const contentsDefaultProps = {
  items: [],
  action: null,
  source: null,
};
